import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { TweenMax, Elastic } from 'gsap'
import { useIntersection } from 'react-use'

const count = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]

const HomeSecureThreatClock = (props) => {
    const blockRefs = []
    blockRefs[0] = useRef(null)
    blockRefs[1] = useRef(null)
    blockRefs[2] = useRef(null)
    blockRefs[3] = useRef(null)
    blockRefs[4] = useRef(null)
    blockRefs[5] = useRef(null)
    blockRefs[6] = useRef(null)
    blockRefs[7] = useRef(null)
    blockRefs[8] = useRef(null)
    blockRefs[9] = useRef(null)

    const intersectionRef = React.useRef(null)
    const intersection = useIntersection(intersectionRef, {
        root: null,
        rootMargin: '0px',
        threshold: 1
    })

    useEffect(() => {
        if (props.total > 0 && intersection && intersection.intersectionRatio >= 1) {
            blockRefs.forEach((blockRef, key) => {
                if (blockRef.current) {
                    const activeItem = blockRef.current.querySelector('.active')
                    const activeClone = activeItem.cloneNode(true)
                    blockRef.current.appendChild(activeClone)
                    activeItem.classList.remove('active')
                    TweenMax.to(blockRef.current, 1.75, {
                        y: -(count.length * 80),
                        ease: Elastic.easeInOut.config(2, 0.5),
                        delay: (key * 0.1)
                    })
                }
            })
        }
    })

    const totalString = () => {
        const totalString = `${props.total}`
        let prefix = ''
        for (let i = 1; i <= (6 - totalString.split('').length); i++) {
            prefix += '0'
        }
        return `${prefix}${props.total}`
    }

    return (
        <div className='row'>
            <div className='col-12 col-md-8 offset-md-2 text-center mb-5'>
                <p className='m-0 mb-3 mt-3 bold font-larger color-indigo'>Home Secure Cyberthreat Clock</p>
                <p className='lh m-0'>This clock tracks the total number of cyberthreats and harmful or inappropriate content events that have been blocked by your Home Secure service since Home Secure started protecting your internet connection.</p>
                <div className='counter-clock mt-5'>
                    <div className='d-flex justify-content-center'>
                        <img src='/images/home-secure/icon-home-secure-plain.svg' alt='' className='mr-4 clock-logo' />
                        <div className='d-flex align-items-center'>
                            <div ref={intersectionRef} className='counter-row'>
                                {totalString().split('').map((number, key) => {
                                    return (
                                        <div key={key} ref={blockRefs[key]} className='counter-block'>
                                            {count.map((countNum, innerKey) => {
                                                return (
                                                    <div key={innerKey} className={`counter-item ${countNum === parseInt(number) ? 'active' : ''}`}>
                                                        {countNum}
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

HomeSecureThreatClock.propTypes = {
    total: PropTypes.number.isRequired
}

export default HomeSecureThreatClock



// WEBPACK FOOTER //
// ./resources/js/components/HomeSecureThreatClock.js